import Store from '@/stores/'
import { useDealConnectV2Store } from '@/piniaStores/dealConnectV2Store'
import { useCompaniesStore } from '@/piniaStores/companiesStore'

export const DEAL_CONNECT_V2_FEATURE_FLAG = 'CF-3950_DEBTDOMAIN_INTEGRATION'
export const DEAL_CONNECT_DASHBOARD_FEATURE_FLAG = 'CF-4605_DEALCONNECT_DASHBOARD'

// Ensures feature flags are loaded, then (if DealConnect V2 is enabled) fetches the
// client's deals and records which companies have them against the companies store.
export async function loadDealConnectV2Deals(): Promise<void> {
  if (!Store.getters['FeatureFlags/featureFlagsLoaded']) {
    await Store.dispatch('FeatureFlags/getFeatureFlags')
  }
  if (!Store.getters['FeatureFlags/isFeatureFlagEnabled'](DEAL_CONNECT_V2_FEATURE_FLAG)) {
    return
  }

  const dealConnectV2Store = useDealConnectV2Store()
  await dealConnectV2Store.fetchDeals()
  const companyIdsWithDeals = [...new Set(dealConnectV2Store.deals.flatMap((deal) => deal.companyId ?? []))]
  useCompaniesStore().setDealConnectV2Deals(companyIdsWithDeals, dealConnectV2Store.deals.length > 0)
}
